/**
 * Porta de entrada do mock (NOVO-38).
 *
 * O gate tem DOIS trincos, e os dois precisam estar abertos:
 *   1. `import.meta.env.DEV` — falso em qualquer build (`vite build` roda em modo production),
 *      então staging e produção nunca entram aqui, mesmo que alguém defina a flag.
 *   2. `VITE_USUARIOS_MOCK === 'true'` — a flag NÃO existe nos heredocs do
 *      `bitbucket-pipelines.yml` (há teste que falha se alguém a adicionar). Ausente vira
 *      `undefined`, e `undefined === 'true'` é falso: seguro por omissão.
 *
 * O `import()` é dinâmico de propósito: com import estático, o msw e as fixtures entrariam no
 * grafo do bundle mesmo com a flag desligada. Assim o Rollup só os alcança por este caminho, que
 * é podado quando `DEV` é constante-falsa no build.
 */
export async function iniciarMockUsuarios(): Promise<boolean> {
  if (!import.meta.env.DEV) return false;
  if (import.meta.env.VITE_USUARIOS_MOCK !== 'true') return false;

  const { iniciarWorker } = await import('./usuarios/browser');
  await iniciarWorker();
  return true;
}
